import { render, staticRenderFns } from "./BotaoImprimir.vue?vue&type=template&id=6c721497&scoped=true"
import script from "./BotaoImprimir.vue?vue&type=script&lang=js"
export * from "./BotaoImprimir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c721497",
  null
  
)

export default component.exports